import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigurationsListComponent } from './configurations-list/configurations-list.component';
import { ConfigurationsDetailComponent } from './configurations-detail/configurations-detail.component';

const routes: Routes = [
    {
        path: 'configurations',
        children: [
            { path: '', component: ConfigurationsListComponent }
        ]
    },
    {
        path: 'configurations/:id',
        children: [
            { path: '', component: ConfigurationsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConfigurationsRoutingModule { }
